import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";

import Hyphenated from 'react-hyphen';
import de from 'hyphenated-de';

import EditButton from "../../../backend/edit-button";
import { pagerFullPageContextAction } from "../../../app-actions";
import Image from "../../image/image";

/**
 * Redux mapStateToProps Function to get information from Redux Store.
 * @param {Object} reduxStore - Redux Store State
 * @returns {{adminApp: *}}
 *   Redux Store.
 */
const mapStateToProps = (reduxStore) => ({
  adminApp: reduxStore.appStore.adminApp,
});

class TeaserProjekt extends Component {
  static defaultProps = { pagerFullPage: false };

  render() {
    return (
      <article
        className="node node-teaser teaser-projekt"
      >
        <EditButton
          adminApp={this.props.adminApp}
          entityId={this.props.item.entityId}
          destinationRoute={this.props.location.pathname}
        />
        <Link
          onClick={() =>
            this.props.dispatch(
              pagerFullPageContextAction(this.props.pagerFullPage)
            )
          }
          className="flex-wrap"
          to={this.props.item.path.alias}
        >
          {this.props.item.fieldTeaserbild.entity.fieldMediaImage &&
            <div className="image-wrapper">
              <Image
                data={this.props.item.fieldTeaserbild.entity.fieldMediaImage}
                nodeTitle={this.props.item.title}
              />
            </div>
          }
          <div className="text-wrap">
            <Hyphenated language={de}>
              <h3>{this.props.item.title}</h3>
            </Hyphenated>
            {this.props.item.fieldTeasertext &&
              <div
                className="text"
                dangerouslySetInnerHTML={{
                  __html: this.props.item.fieldTeasertext.processed,
                }}
              />
            }
          </div>
        </Link>
      </article>
    );
  }
}

export const teaserProjectPropTypes = PropTypes.shape({
  entityId: PropTypes.string,
  title: PropTypes.string,
  path: PropTypes.shape({
    alias: PropTypes.string,
  }),
  fieldSchlagwort: PropTypes.arrayOf(
    PropTypes.shape({
      entity: PropTypes.shape({
        name: PropTypes.string,
      }),
    })
  ),
  fieldTeaserbild: PropTypes.shape({
    entity: PropTypes.shape({
      fieldMediaImage: PropTypes.shape({
        alt: PropTypes.string,
        title: PropTypes.string,
        style: PropTypes.shape({
          url: PropTypes.string,
        }),
      }),
    }),
  }),
});

TeaserProjekt.propTypes = {
  adminApp: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  item: teaserProjectPropTypes,
  location: PropTypes.object.isRequired,
  pagerFullPage: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
    .isRequired,
};

export default connect(mapStateToProps)(withRouter(TeaserProjekt));
